const TWO_FA_TTL_MS = 5 * 60 * 1000;

export interface PendingTwoFactorFromUrl {
  challengeId: string;
  expiresAt: string;
}

export const getPendingTwoFactorFromUrl = (
  search = window.location.search,
): PendingTwoFactorFromUrl | null => {
  const params = new URLSearchParams(search);
  if (params.get("auth_2fa") !== "pending") return null;

  const challengeId = params.get("challenge_id");
  if (!challengeId) return null;

  const expiresAt =
    params.get("expires_at") ??
    new Date(Date.now() + TWO_FA_TTL_MS).toISOString();

  return { challengeId, expiresAt };
};

export const hasPendingTwoFactorInUrl = (search = window.location.search) =>
  getPendingTwoFactorFromUrl(search) !== null;
